// Bootstrap 3's stepped content widths (720 / 940 / 1140px), which Vue 2's collection page sat in; the shared
// container is fluid below 1200px.
export const BOOTSTRAP_CONTAINER = 'container md:max-w-[752px] lg:max-w-[972px] xl:max-w-[1172px]'
